export const occupiesPublishSlot = (status) => {
  const normalized = String(status || '').toLowerCase();
  return normalized === 'creating' || normalized === 'running';
};

export const canUseReadyApps = (entitlement) =>
  Boolean(entitlement?.hasPackage) && Number(entitlement?.maxActivePublishes ?? 0) > 0;

export const hasPublishSlotRemaining = (entitlement) =>
  Number(entitlement?.publishSlotsRemaining ?? 0) > 0;
